import secureStorage from './secureStorage';
import { cachedFetch } from './pageCache';

/**
 * fetch() wrapper that auto-injects the Authorization header from
 * secureStorage. Drop-in replacement for window.fetch — same signature.
 * Also forwards the X-View-As-Org header for super-admin previews.
 */
export default function authedFetch(input, init = {}) {
  const headers = new Headers(init.headers || {});

  try {
    const token = secureStorage.getItem('session_token');
    if (token && !headers.has('Authorization')) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    const viewAsOrg = sessionStorage.getItem('viewAsOrg');
    if (viewAsOrg && !headers.has('X-View-As-Org')) {
      const parsed = JSON.parse(viewAsOrg);
      if (parsed?.id) headers.set('X-View-As-Org', parsed.id);
    }
    // Optional companion header: super-admin module-preview lets a
    // super admin temporarily ask /me/modules "what would this role
    // see for this org?". Set by ModulesTab's Preview button; cleared
    // by Header's exit-preview action alongside X-View-As-Org.
    const viewAsRole = sessionStorage.getItem('viewAsRole');
    if (viewAsRole && !headers.has('X-View-As-Role')) {
      headers.set('X-View-As-Role', viewAsRole);
    }
  } catch {
    /* ignore storage failures */
  }

  const doFetch = () => fetch(input, { credentials: 'include', ...init, headers });
  return cachedFetch(doFetch, input, { ...init, headers });
}
